// IMPORT PACKAGE REFERENCES
import React, { Component, Fragment } from 'react';

import { AnalysisCompleteUserStatsTable } from './AnalysisCompleteUserStatsTable';
import { Error } from '../../shared/Error/Error';
import { LoadingIndicator } from '../../shared/LoadingIndicator/LoadingIndicator';
import Pager from '../../shared/Pager/Pager';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// IMPORT PROJECT REFERENCES
import { fetchAnalysisCompleteUserStats } from '../../state/actions/AnalysisActions';

// COMPONENT
class AnalysisCompleteUserStatsBrowser extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { startDate, endDate, pageSize } = this.props;

        this.props.fetchAnalysisCompleteUserStats(startDate, endDate, 1, pageSize);
    }

    componentDidUpdate(prevProps) {
        const { pageNumber, pageSize } = this.props.paging;
        const { fetchAnalysisCompleteUserStats, startDate, endDate } = this.props;

        if (prevProps.startDate != startDate || prevProps.endDate != endDate) {
            fetchAnalysisCompleteUserStats(startDate, endDate, pageNumber, pageSize);
        }
    }

    handlePageClick = data => {
        let { pageNumber } = data;
        const { startDate, endDate } = this.props;
        const { pageSize } = this.props.paging;

        this.props.fetchAnalysisCompleteUserStats(startDate, endDate, pageNumber, pageSize);
    };

    render() {
        const { analysisCompleteUserStats, failed, fetched, fetching, paging } = this.props;

        if (!fetched) {
            return <LoadingIndicator busy={fetching} />;
        }

        if (failed) {
            return <Error message="Failed to fetch analysis records" />;
        }

        if (analysisCompleteUserStats) {
            const { pages, pageNumber } = paging;

            const noRecords = !analysisCompleteUserStats.length && <div>No records found</div>;

            return (
                <Fragment>
                    {noRecords ? (
                        noRecords
                    ) : (
                        <Fragment>
                            <AnalysisCompleteUserStatsTable
                                analysisCompleteUserStats={analysisCompleteUserStats}
                            />
                            <Pager
                                pages={pages}
                                pageNumber={pageNumber}
                                onPageChange={this.handlePageClick}
                            />
                        </Fragment>
                    )}
                </Fragment>
            );
        }

        return null;
    }
}

AnalysisCompleteUserStatsBrowser.propTypes = {
    fetchAnalysisCompleteUserStats: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    pageSize: PropTypes.number.isRequired,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    analysisCompleteUserStats: PropTypes.array,
    failed: PropTypes.bool,
    paging: PropTypes.shape({
        pages: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        pageNumber: PropTypes.number.isRequired,
    }),
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, paging, analysisCompleteUserStats } = state.analyses;

    return { fetching, fetched, failed, paging, analysisCompleteUserStats };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({ fetchAnalysisCompleteUserStats }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AnalysisCompleteUserStatsBrowser);

// EXPORT COMPONENT
export { hoc as AnalysisCompleteUserStatsBrowser };
